<template>
	<div class="landing-page privacy">

		<!-- Top navbar -->
		<landing-page-navbar></landing-page-navbar>
		<div class="content-container">

			<div class="container" v-if="carrierDetails">
				<div class="row" v-if="carrierDetails.countryCodeAlpha2 != 'DE'">
                    <div class="col-md-10 col-lg-8">
                        <div class="privacy">
                            <div class="header">
                                <h1>{{$t('bp.privacyPolicy.Cap')}}</h1>
                              <template v-if="!carrierDetails.privacyLink && countryCodeSetting !== 'GB'">
                                    <p>This Application collects some Personal Data from its Users.</p>
                                    <p>Personal Data collected for the following purposes and using the following services:</p>
                                </template>
                            </div>

                            <div class="contain">
                              <div id="ukPolicy" v-if="countryCodeSetting === 'GB'">
                                <h3>Introduction</h3>
                                <p>
                                  Welcome to our privacy notice. In this document we explain, in plain language, how we use your personal data and what rights you have in relation to it. We also explain what you can expect from us and how to get in touch.
                                </p>
                                <p>
                                  We are not asking you to agree to this notice; this is our explanation of what we will, and will not, do with your data.
                                </p>
                                <p>
                                  We have divided this privacy policy into sections so you can easily access the part you want to read, although we hope you will read the whole thing.
                                </p>
                                <p>
                                  We keep our privacy policy under regular review. This is version 2.0 of our privacy policy and was updated on 9th June 2026.
                                </p>

                                <h3>Who we are</h3>
                                <p>
                                  We are <strong>Likewize Services UK Limited</strong>, part of the Likewize group of companies. This privacy notice covers our processing of your data in relation to your current transaction with us.
                                  More information about our group privacy practices and our relationship with other companies in the Likewize group can be found on our corporate website at
                                  <a target="_blank" href="https://www.likewize.com/privacy">www.likewize.com/privacy</a>.
                                </p>
                                <p>
                                  If you need to get in touch with us about a Data Protection issue, or if you have a specific complaint to make in the UK, all queries should be addressed to the Data Protection Lead, who is the point of contact for people in the UK and Europe and who is our Data Protection Officer.
                                </p>
                                <p>
                                  The quickest way to get in touch is by email to <a href="mailto:privacy@likewize.com">privacy@likewize.com</a>.
                                </p>
                                <p>
                                  You can also write to us at:<br>
                                  Likewize Services UK<br>
                                  Crewe Logistics Park<br>
                                  Jack Mills Way<br>
                                  Shavington<br>
                                  Crewe<br>
                                  CW2 5XF
                                </p>
                                <p>
                                  Finally, you can call us on 01270 412020.
                                </p>

                                <h3>What personal data we need to collect from you</h3>
                                <p>
                                  We have to collect your personal data to enable you to use some of our services, but some data is optional. We make it clear when you have a choice and when we need the data to provide our services. For some information, if you do not provide it, we will not be able to do business with you.
                                </p>
                                <p>
                                  We collect your personal details including your name, address, title and date of birth. We collect your home address and may collect other addresses where necessary to provide our services. This may include delivery addresses, billing addresses, or addresses where we provide our We Come To You repair service. We also collect other contact details including email addresses and phone numbers.
                                </p>
                                <p>
                                  We collect and use your payment card details when we take a payment from you, but we do not retain these details ourselves. We use payment processors (specialists in secure transactions) to retain any necessary details. Where you sign up to subscription services we offer, we store your permission to charge your card on a continuing basis.
                                </p>
                                <p>
                                  We collect details of your dealings with us, including services you purchased. We also collect and retain details about the health of your device including cosmetic state and battery health. This data may be linked back to you through the use of unique device identifiers such as the IMEI.
                                </p>
                                <p>
                                  We collect technical details about your web browser and sometimes about your device as part of our web server load balancing and security measures.
                                </p>
                                <p>
                                  Sometimes you might take part in a customer experience or website survey and, where you do, we collect information about your preferences and the answers you give.
                                </p>
                                <p>
                                  When you are using our website, information about how you use it and the links you have clicked will be collected to help us improve our website.
                                </p>
                                <p>
                                  We collect data through cookies and other website technologies. You can find more details in our separate cookie policy.
                                </p>
                                <p>
                                  We also collect details about your marketing or communications preferences.
                                </p>
                                <p>
                                  We do not intentionally collect special category (sensitive) data about you.
                                </p>

                                <h3>Our lawful bases for using your data</h3>
                                <p>
                                  Data protection law means we need one of several lawful bases to use your data. Consent is one, but there are others.
                                </p>
                                <p>
                                  We need your contact details, financial information and addresses to provide our services, such as repairing your mobile phone or other device. Our lawful basis is that we need the data to fulfil our contract with you or to take steps to enter into a contract with you.
                                </p>
                                <p>
                                  We also need device details, including IMEI number, to enter into a contract with you. Where we keep data about the health of your device as part of our subscription services, that is also used because it is necessary to fulfil our contract with you.
                                </p>
                                <p>
                                  We also have to collect and keep data to retain accurate financial records about our transactions. This lawful basis is compliance with a legal obligation.
                                </p>
                                <p>
                                  Your survey data and technical data about the way you use our site are used because it is in our legitimate interests to improve our site and our services.
                                </p>
                                <p>
                                  Sometimes we use your contact details to send required documentation (such as changes to our terms and conditions or this privacy policy). We do this when it is a legal obligation.
                                </p>
                                <p>
                                  When we send you direct marketing materials by electronic means, including email or device push notifications, we do so only where we have your consent. You can withdraw consent at any time by using unsubscribe links, logging into any portal we provide, or by emailing <a href="mailto:privacy@likewize.com">privacy@likewize.com</a>.
                                </p>

                                <h3>Who do we share your data with?</h3>
                                <p>
                                  The first group of recipients is other companies in the Likewize group. We have internal group contracts that specify what they can do with your data and what security processes they must follow. Different companies in our group perform different functions, such as IT development and cyber security. We are a multinational group and some group companies are in countries with different data protection laws. Where this is the case, we put specific contracts approved by the UK Information Commissioner&rsquo;s Office in place.
                                </p>
                                <p>
                                  The second group is service providers such as our specialist payment provider, professional advisors and auditors. These providers help us operate our website and services and, for payment card data, help us keep your data secure. Some providers are overseas, so we use appropriate contracts to protect your data.
                                </p>
                                <p>
                                  The third group is regulators and public authorities we are required to share data with, such as HMRC or the Information Commissioner&rsquo;s Office.
                                </p>
                                <p>
                                  Where we perform a health check on your device, we share data about your device with our health-check partner, Pandas, at <a target="_blank" href="https://www.pandas.io">www.pandas.io</a>.
                                </p>
                                <p>
                                  To offer Klarna payment options, we pass certain personal information such as contact and order details so Klarna can assess suitability and tailor payment options. General information on Klarna is available at
                                  <a target="_blank" href="https://www.klarna.com/uk/terms-and-conditions/">https://www.klarna.com/uk/terms-and-conditions/</a>.
                                  Your personal data is handled in accordance with applicable data protection law and Klarna&rsquo;s privacy policy.
                                </p>
                                <p>
                                  We may also share details with fraud prevention agencies, including agencies specific to the telecommunications sector.
                                </p>
                                <p>
                                  If you want more details about international data transfers, please contact us using the details above.
                                </p>
                                <p>
                                  We do not sell your personal data to others. We only share it for the purposes of providing our services.
                                </p>

                                <h3>How long do we keep your data for?</h3>
                                <p>
                                  The general rule is that we only keep your data for as long as we need it, but there are some specific timescales.
                                </p>
                                <p>
                                  Where a financial transaction has taken place, we keep the data for six years plus the remainder of the current financial year.
                                </p>
                                <p>
                                  Where there is a legal reason to hold data for longer (for example, while resolving a complaint), we may retain your data for longer.
                                </p>

                                <h3>Your rights in relation to your data</h3>
                                <p>
                                  You can exercise any of these rights using the contact details at the top of this page. The easiest way to contact us is <a href="mailto:privacy@likewize.com">privacy@likewize.com</a>.
                                </p>
                                <ul>
                                  <li><strong>Right of access:</strong> You can ask for a copy of your personal data and related information. We normally respond within one month.</li>
                                  <li><strong>Right of rectification:</strong> You can ask us to correct inaccurate information.</li>
                                  <li><strong>Right to erasure:</strong> In some circumstances you can ask us to erase your data, although legal or contractual obligations may mean we cannot erase everything.</li>
                                  <li><strong>Right to object:</strong> You have an absolute right to object to direct marketing. You can also object where we rely on legitimate interests.</li>
                                  <li><strong>Right to restriction:</strong> You can ask us to restrict processing while a dispute is resolved.</li>
                                  <li><strong>Right to data portability:</strong> In some cases you can ask for your data in a portable format.</li>
                                  <li><strong>Right to withdraw consent:</strong> Where we rely on consent, you can withdraw it at any time.</li>
                                </ul>

                                <h3>The right to complain</h3>
                                <p>
                                  To make a data protection complaint, email <a href="mailto:privacy@likewize.com">privacy@likewize.com</a> with:
                                </p>
                                <ul>
                                  <li>Your name, email address and any details that help identify you</li>
                                  <li>The details of your complaint</li>
                                  <li>Why you think we have failed to follow data protection law</li>
                                </ul>
                                <p>
                                  You can also complain to the UK Information Commissioner&rsquo;s Office at <a target="_blank" href="https://www.ico.org.uk">www.ico.org.uk</a>. They may expect you to have complained to us first.
                                </p>

                                <h3>What we may need from you</h3>
                                <p>
                                  We may need to request specific information to confirm your identity and your right to access your personal data (or exercise any other rights). This is a security measure to ensure personal data is not disclosed to anyone without entitlement. We may also contact you for further information to speed up our response.
                                </p>
                              </div>

                              <div id="smallPolicy" v-if="carrierDetails.privacyLink && countryCodeSetting !== 'GB'">
                                    <hr>
                                    <a target="_blank" :href="carrierDetails.privacyLink">{{$t('bp.privacyPolicy.text')}}</a>
                                </div>

                              <div id="smallPolicy" v-if="!carrierDetails.privacyLink && countryCodeSetting !== 'GB'">
                                    <h3>Analytics</h3>
                                    <p><strong>Google Analytics and Google Adwords conversion tracking</strong>
                                        <br>Personal Data: Cookies and Usage data
                                    </p>

                                    <h3>Contacting The User</h3>
                                    <strong>Contact form</strong>
                                    <p>Personal Data: address, country, email address, first name, last name, phone number and ZIP/Postal code</p>

                                    <strong>Mailing List or Newsletter</strong>
                                    <p>Personal Data: email address</p>

                                    <strong>Phone contact</strong>
                                    <p>Personal Data: phone number</p>


                                    <h3>Displaying Content From External Platforms</h3>
                                    <strong>Google Maps widget</strong>
                                    <p>Personal Data: Cookies and Usage data</p>

                                    <div v-if="carrierDetails.usesKlarna">
                                        <h3>Heat Mapping</h3>
                                        <strong>SessionCam</strong>
                                        <p>Personal Data: Cookies and Usage data</p>
                                    </div>

                                    <h3>Contact information</h3>
                                    <strong>Data owner</strong>
                                    <p>{{ carrierDetails.address }}</p>

                                    <div v-if="carrierDetails.usesKlarna">
                                        <h3>Klarna Payments</h3>
                                        <p>
                                            In order to be able to offer you Klarna’s payment options, we will pass to Klarna certain aspects of your personal information, such as contact and order details, in order for Klarna to assess whether you qualify for their payment options and to tailor the payment options for you.
                                            General information on Klarna can be found <a href="https://www.klarna.com/uk/terms-and-conditions" target="_blank">here</a>. Your personal data is handled in accordance with applicable data protection law and in accordance with the information in Klarna’s privacy policy.
                                        </p>
                                    </div>
                                </div>

                                <div id="fullPolicy" style="display: none;" v-if="countryCodeSetting !== 'GB'">
                                    (Full Privacy Policy)

                                    <h3>Types of Data collected</h3>

                                    <p>Among the types of Personal Data that this Application collects, by itself or through third parties, there are: first name, last name, phone number, address, country, email address, Postal code, Cookies and Usage data.</p>

                                    <p>Other Personal Data collected may be described in other sections of this privacy policy or by dedicated explanation text contextually with the Data collection.
                                        The Personal Data may be freely provided by the User, or collected automatically when using this Application.</p>

                                    <p>Any use of Cookies - or of other tracking tools - by this Application or by the owners of third party services used by this Application, unless stated otherwise, serves to identify Users and remember their preferences, for the sole purpose of providing the service required by the User.
                                        Failure to provide certain Personal Data may make it impossible for this Application to provide its services.</p>

                                    <p>Users are responsible for any Personal Data of third parties obtained, published or shared through this Application and confirm that they have the third party's consent to provide the Data to the Owner.</p>


                                    <h3>Mode and place of processing the Data</h3>

                                    <p>Methods of processing
                                        The Data Controller processes the Data of Users in a proper manner and shall take appropriate security measures to prevent unauthorised access, disclosure, modification, or unauthorised destruction of the Data.</p>

                                    <p>The Data processing is carried out using computers and/or IT enabled tools, following organisational procedures and modes strictly related to the purposes indicated. In addition to the Data Controller, in some cases, the Data may be accessible to certain types of persons in charge, involved with the operation of the site (administration, sales, marketing, legal, system administration) or external parties (such as third party technical service providers, mail carriers, hosting providers, IT companies) appointed, if necessary, as Data Processors by the Owner. The updated list of these parties may be requested from the Data Controller at any time.</p>

                                    <strong>Place</strong>
                                    <p>The Data is processed at the Data Controller's operating offices and in any other places where the parties involved with the processing are located. For further information, please contact the Data Controller.</p>



                                    <strong>Retention time</strong>
                                    <p>The Data is kept for the time necessary to provide the service requested by the User, or stated by the purposes outlined in this document, and the User can always request that the Data Controller suspend or remove the data.</p>




                                    <h3>The use of the collected Data</h3>
                                    <p>The Data concerning the User is collected to allow the Owner to provide its services, as well as for the following purposes: Contacting the User, Analytics, Heat mapping, Displaying content from external platforms.</p>

                                    <p>The Personal Data used for each purpose is outlined in the specific sections of this document.</p>



                                    <h3>Detailed information on the processing of Personal Data</h3>
                                    <p>Personal Data is collected for the following purposes and using the following services:</p>


                                    <h3>Analytics:</h3>
                                    <p>The services contained in this section enable the Owner to monitor and analyse web traffic and can be used to keep track of User behaviour.</p>

                                    <strong>Google Analytics (Google Inc.)</strong>
                                    <p>Google Analytics is a web analysis service provided by Google Inc. (“Google”). Google utilises the Data collected to track and examine the use of this Application, to prepare reports on its activities and share them with other Google services.
                                        Google may use the Data collected to contextualise and personalise the ads of its own advertising network.</p>

                                    <p>Personal Data collected: Cookies and Usage data.</p>

                                    <p>Place of processing: US – Privacy Policy (https://www.google.com/intl/en/policies/privacy/)  – Opt Out (https://tools.google.com/dlpage/gaoptout?hl=en)</p>

                                    <strong>Google AdWords conversion tracking (Google Inc.)</strong>
                                    Google AdWords conversion tracking is an analytics service provided by Google Inc. that connects data from the Google AdWords advertising network with actions performed on this Application.

                                    <p>Personal Data collected: Cookies and Usage data.</p>

                                    <p>Place of processing: US – Privacy Policy (https://www.google.com/intl/en/policies/privacy/)</p>



                                    <h3>Contacting The User</h3>
                                    <strong>Contact form (This Application)</strong>
                                    <p>By filling in the contact form with their Data, the User authorises this Application to use these details to reply to requests for information, quotes or any other kind of request as indicated by the form’s header.</p>

                                    <p>Personal Data collected: address, country, email address, first name, last name, phone number and ZIP/Postal code.</p>

                                    <strong>Phone contact (This Application)</strong>
                                    <p>Users that provided their phone number might be contacted for commercial or promotional purposes related to this Application, as well as for fulfilling support requests.</p>

                                    <p>Personal Data collected: phone number.</p>

                                    <h3>Displaying content from external platforms</h3>
                                    <p>This type of services allows you to view content hosted on external platforms directly from the pages of this Application and interact with them.</p>
                                    <p>This type of service might still collect web traffic data for the pages where the service is installed, even when Users do not use it.</p>

                                    <strong>Google Maps widget (Google)</strong>
                                    <p>Google Maps is a maps visualisation service provided by Google Inc. that allows this Application to incorporate content of this kind on its pages.</p>

                                    <p>Personal Data collected: Usage data.</p>

                                    <p>Place of processing: US – Privacy Policy (https://www.google.com/intl/en/policies/privacy/)</p>

                                    <div v-if="carrierDetails.usesKlarna">
                                        <h3>Heat Mapping</h3>
                                        <p>Heat Mapping services are used to display the areas of a page where Users most frequently move the mouse or click. This shows where the points of interest are. These services make it possible to monitor and analyse web traffic and keep track of User behaviour.</p>

                                        <p>Crazy Egg (Crazy Egg, Inc.) is a Heat Mapping service provided by Crazy Egg, Inc.</p>

                                        <p>Personal Data collected: Cookies and Usage data.</p>

                                        <p>Place of processing: US - Privacy Policy (Crazy Egg Privacy Policy - https://www.crazyegg.com/privacy)</p>
                                    </div>


                                    <h3>Additional information about Data collection and processing</h3>
                                    <strong>Legal action</strong>
                                    <p>The User's Personal Data may be used for legal purposes by the Data Controller, in Court or in the stages leading to possible legal action arising from improper use of this Application or the related services.</p>

                                    <p>The User declares to be aware that the Data Controller may be required to reveal personal data upon request of public authorities.</p>

                                    <strong>Additional information about User's Personal Data</strong>
                                    <p>In addition to the information contained in this privacy policy, this Application may provide the User with additional and contextual information concerning particular services or the collection and processing of Personal Data upon request.</p>

                                    <strong>System logs and maintenance</strong>
                                    <p>For operation and maintenance purposes, this Application and any third party services may collect files that record interaction with this Application (System logs) or use for this purpose other Personal Data (such as IP Address).</p>

                                    <strong>Information not contained in this policy</strong>
                                    <p>More details concerning the collection or processing of Personal Data may be requested from the Data Controller at any time. Please see the contact information at the beginning of this document.</p>

                                    <strong>The rights of Users</strong>
                                    <p>Users have the right, at any time, to know whether their Personal Data has been stored and can consult the Data Controller to learn about their contents and origin, to verify their accuracy or to ask for them to be supplemented, cancelled, updated or corrected, or for their transformation into anonymous format or to block any data held in violation of the law, as well as to oppose their treatment for any and all legitimate reasons. Requests should be sent to the Data Controller at the contact information set out above.</p>

                                    <strong>This Application does not support “Do Not Track” requests.</strong>
                                    <p>To determine whether any of the third party services it uses honour the “Do Not Track” requests, please read their privacy policies.</p>

                                    <strong>Changes to this privacy policy</strong>
                                    <p>The Data Controller reserves the right to make changes to this privacy policy at any time by giving notice to its Users on this page. It is strongly recommended to check this page often, referring to the date of the last modification listed at the bottom. If a User objects to any of the changes to the Policy, the User must cease using this Application and can request that the Data Controller remove the Personal Data. Unless stated otherwise, the then-current privacy policy applies to all Personal Data the Data Controller has about Users.</p>

                                    <strong>Information about this privacy policy</strong>
                                    <p>The Data Controller is responsible for this privacy policy.</p>
                                </div>

                                <template v-if="countryCodeSetting !== 'GB'">
                                  <hr>

                                  <div v-if="countryCodeSetting === 'AU'">
                                    <a target="_blank" href="https://likewize-files.s3.eu-west-2.amazonaws.com/au/documents/Likewize_AU_Privacy_Policy.pdf">Click to see our full privacy policy</a> <img src="https://wefix-files.s3.eu-west-2.amazonaws.com/images/icons/general/pdf_32x32.png" alt="Adobe">
                                  </div>
                                </template>
                            </div>
                        </div>
					</div>
				</div>
        <div class="row" v-else>
          <h1 class="w-100 mb-4">Datenschutzerklärung Likewize Europe GmbH</h1><br>
          <h2 class="w-100 mb-4">Datenschutzerklärung</h2>
          <h3 class="w-100 mb-4">Einleitung</h3>
          <p class="mb-0 w-100">Willkommen zu unserer Datenschutzerklärung. In diesem Dokument erläutern wir Ihnen in
            klarer und verständlicher Sprache, wie wir Ihre personenbezogenen Daten verwenden, welche Rechte Sie haben
            und was Sie von uns erwarten können.
            Wir bitten Sie nicht um Ihre Zustimmung zu dieser Erklärung; sie dient ausschließlich dazu, Sie darüber zu
            informieren, wie wir mit Ihren Daten umgehen.</p>
          <p class="w-100">Zur besseren Übersicht haben wir diese Datenschutzerklärung in verschiedene Abschnitte
            gegliedert. Wir überprüfen sie regelmäßig. Dies ist Version 1.0, zuletzt aktualisiert am 10. April 2026.</p>
          <h3 class="w-100 my-4">Wer wir sind</h3>
          <p>Wir sind Likewize Europe GmbH, Teil der Likewize-Unternehmensgruppe. Diese Datenschutzerklärung beschreibt
            die Verarbeitung Ihrer personenbezogenen Daten im Zusammenhang mit Ihrer aktuellen Transaktion mit uns.
            Weitere Informationen zu den Datenschutzpraktiken der Likewize-Gruppe finden Sie unter: <a
                href="https://www.likewize.com/privacy/">www.likewize.com/privacy/</a></p>
          <h3 class="w-100 my-4">Kontakt zum Datenschutzbeauftragten</h3>
          <p class="mb-0 w-100"><strong>E-Mail:</strong> privacy@likewize.com</p>
          <p class="mb-0 w-100"><strong>Postanschrift:</strong> Datenschutzbeauftragter</p>
          <p class="mb-0 w-100">Ratinger Str. 10</p>
          <p class="mb-0 w-100">42579 Heiligenhaus</p>
          <p class="mb-0 w-100">Deutschland</p>
          <h3 class="w-100 my-4">
            Personenbezogene Daten, die wir erheben oder verarbeiten
          </h3>
          <p>Wir erheben und verarbeiten personenbezogene Daten, die notwendig sind, um unsere Dienstleistungen zu
            erbringen. Einige Angaben sind nicht verpflichtend; wir informieren Sie, wenn Sie eine Wahl haben.</p>
          <h3 class="w-100 my-4">Zu den von uns erhobenen Daten gehören:</h3>
          <ul>
            <li>Name, Adresse (Liefer- und Rechnungsadressen)</li>
            <li>E-Mail-Adresse, Telefonnummern</li>
            <li>Finanzdaten wie Bankverbindungen, Kontonummern, Sort Codes, Zahlungskartendaten</li>
            <li>Geräteinformationen, IMEI-Nummern, Transaktionsdaten, erworbene Dienstleistungen</li>
            <li>Angaben aus Umfragen oder Website-Feedback</li>
            <li>Technische Daten über Ihre Nutzung unserer Website</li>
            <li>Kommunikations- und Marketingpräferenzen</li>
          </ul>
          <p class="mb-0 w-100">Wir erheben keine besonderen Kategorien personenbezogener Daten und keine Daten zu
            strafrechtlichen Verurteilungen über diese Website.</p>
          <p class="w-100">Bitte informieren Sie uns über Änderungen Ihrer Daten, damit diese aktuell bleiben.</p>
          <h3 class="w-100 my-4">Rechtsgrundlagen für die Verarbeitung Ihrer Daten</h3>
          <p>Wir verarbeiten Ihre Daten auf Basis folgender Rechtsgrundlagen:</p>
          <h3 class="w-100 my-4">Vertragserfüllung</h3>
          <p>Wir benötigen Ihre Kontaktdaten, Finanzinformationen und Gerätedaten, um unsere Dienstleistungen zu
            erbringen.</p>
          <h3 class="w-100 my-4">Gesetzliche Verpflichtung</h3>
          <p>Wir müssen bestimmte Daten speichern, insbesondere für Finanz- und Steuerzwecke.</p>
          <h3 class="w-100 my-4">Berechtigte Interessen</h3>
          <p>Wir verarbeiten Daten zur Pflege unserer Geschäftsbeziehung mit Samsung sowie zur Verbesserung unserer
            Website und Dienstleistungen.</p>
          <h3 class="w-100 my-4">Rechtliche Informationspflichten</h3>
          <p>Wir verwenden Ihre Kontaktdaten, um Ihnen gesetzlich vorgeschriebene Mitteilungen zu senden.</p>
          <h3 class="w-100 my-4">Weitergabe Ihrer Daten und internationale Datenübermittlungen</h3>
          <p>Wir geben Ihre Daten an folgende Empfänger weiter:</p>
          <h3 class="w-100 my-4">Unternehmen der Likewize-Gruppe</h3>
          <p>Wir nutzen interne Vereinbarungen und EU-Standardvertragsklauseln, wenn Daten in Länder außerhalb der EU
            übermittelt werden.</p>
          <h3 class="w-100 my-4">Dienstleister und externe Anbieter</h3>
          <p>Zahlungsdienstleister, IT-Anbieter, Logistikpartner, Berater, Auditoren. Auch hier stellen wir geeignete
            Schutzmaßnahmen sicher.</p>
          <h3 class="w-100 my-4">Behörden</h3>
          <p>Wenn wir gesetzlich verpflichtet sind, Daten weiterzugeben.</p>
          <p>Wir verkaufen Ihre Daten nicht.</p>
          <h3 class="w-100 my-4">Speicherdauer Ihrer Daten</h3>
          <p>Wir speichern Ihre Daten nur so lange wie notwendig.</p>
          <h3 class="w-100 my-4">Typische Aufbewahrungsfristen:</h3>
          <ul>
            <li>Finanztransaktionen: 6 Jahre plus laufendes Geschäftsjahr</li>
            <li>Umsatzsteuerrelevante Daten: 10 Jahre</li>
            <li>Angebote ohne Abschluss: bis zu 1 Jahr</li>
            <li>Längere Speicherung bei rechtlichen Gründen (z. B. Beschwerden)</li>
          </ul>
          <h3 class="w-100 my-4">Ihre Rechte</h3>
          <p>Sie können Ihre Rechte über die oben genannten Kontaktwege ausüben.</p>
          <h3 class="w-100 my-4">Recht auf Auskunft</h3>
          <p>Sie können eine Kopie Ihrer personenbezogenen Daten anfordern. Dies ist in der Regel kostenlos.</p>
          <h3 class="w-100 my-4">Recht auf Berichtigung</h3>
          <p>Sie können die Korrektur unrichtiger Daten verlangen. Bei Meinungsangaben können Sie eine ergänzende
            Erklärung hinzufügen lassen.</p>
          <h3 class="w-100 my-4">Recht auf Löschung</h3>
          <p>Sie können die Löschung nicht erforderlicher Daten verlangen. Gesetzliche Aufbewahrungspflichten können
            eine vollständige Löschung verhindern.</p>
          <h3 class="w-100 my-4">Widerspruchsrecht</h3>
          <p>Sie können der Direktwerbung jederzeit widersprechen. Bei Verarbeitung auf Basis berechtigter Interessen
            prüfen wir Ihren Widerspruch.</p>
          <h3 class="w-100 my-4">Recht auf Einschränkung der Verarbeitung</h3>
          <p>Sie können eine Einschränkung verlangen, wenn eine Klärung erforderlich ist.</p>
          <h3 class="w-100 my-4">Recht auf Datenübertragbarkeit</h3>
          <p>In bestimmten Fällen können Sie Ihre Daten in einem übertragbaren Format anfordern.</p>
          <h3 class="w-100 my-4">Recht auf Widerruf der Einwilligung</h3>
          <p>Wenn wir Daten auf Basis Ihrer Einwilligung verarbeiten, können Sie diese jederzeit widerrufen.</p>
          <h3 class="w-100 my-4">Beschwerderecht</h3>
          <p class="w-100">Sie können sich jederzeit an die zuständige Aufsichtsbehörde wenden:</p>
          <p class="mb-0 w-100">Landesbeauftragte für Datenschutz und Informationsfreiheit Nordrhein-Westfalen</p>
          <p class="mb-0 w-100">Kavalleriestraße 2-4</p>
          <p class="mb-0 w-100">40213 Düsseldorf</p>
          <p class="mb-0 w-100">Telefon: (0211) 38424-0</p>
          <p class="mb-0 w-100">Fax: (0211) 38424-999</p>
          <p class="mb-0 w-100">E-Mail: <a href="mailto:poststelle@ldi.nrw.de">poststelle@ldi.nrw.de</a></p>
        </div>
			</div>
		</div>

		<!-- Footer -->
		<page-footer></page-footer>
	</div>
</template>

<script>
if (process.env.VUE_APP_PARTNER_ENVIRONMENT) {
	require('@/styles/core/whitelabel/'+process.env.VUE_APP_PARTNER_ENVIRONMENT+'.scss');
} else {
	require('@/styles/core/whitelabel/wefix.scss');
}

import {mapGetters} from "vuex";

export default {
	name: "PrivacyIndex",

	computed: {
		...mapGetters([
			'carrierDetails',
            'countryCodeSetting'
		])
	}
}
</script>

<style scoped>

#ukPolicy {
  line-height: 1.65;
}

#ukPolicy h3 {
  margin-top: 1.75rem;
  margin-bottom: 0.75rem;
}

#ukPolicy h4 {
  margin-top: 1.25rem;
  margin-bottom: 0.5rem;
}

#ukPolicy ul {
  margin-bottom: 1rem;
  padding-left: 1.25rem;
}

#ukPolicy p {
  margin-bottom: 0.9rem;
}

</style>